// This is the Body section of the page which is composed by the
// three information sections which includes "Make a strong offer on your dream home!" information,
// About Sun West Mortgage Company (NMLS ID 3277) information, and the Texas disclaimer.
import React, { Suspense, useEffect, useState, useRef, lazy } from 'react'
import { Container, Col, Row, Image } from 'react-bootstrap';
import '../Body/body.css'
import AboutGroup from '../Images/AboutGroup.png'
import AboutGroupMobile from '../Images/AboutGroupMobile.png'
import LeftDots from '../Images/Left-dots.png'
import RightDots from '../Images/Right-dots.png'
import RightDotsOffer from '../Images/Right-dots.png'
import LeftDotsOffer from '../Images/Right-dots.png'
import HappyCouple from '../Images/HappyCouple.png'
import axios from "axios";
import parser from "html-react-parser";

export default function Body({sunwestLink1, pavanLink, sunwestLink, sunwestLink2}) {
  const ref = useRef();
  const [isIntersecting, setIntersecting] = useState(false);
  const [footerInfoData, setFooterInfoData] = useState();

  useEffect(() => {
    const fetchSWMCFooterInfo = async () => {
      try {
        await axios
          .get(process.env.REACT_APP_SWMC_FOOTET_INFO)
          .then((response) => {
            //console.log(response.data);
            setFooterInfoData(response.data);
            const observer = new IntersectionObserver(([entry]) => {
              if (entry.isIntersecting) {
                setIntersecting(entry.isIntersecting);
                observer.disconnect();
              }
            });
            observer.observe(ref.current);
            // Remove the observer as soon as the component is unmounted
            return () => {
              observer.disconnect();
            };
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    fetchSWMCFooterInfo();
  }, []);
  const getSunWestSuccessYears = () => {
    // Sun West founded in 08/12/1980 in PST
    const foundedDate = new Date("1980-08-12T00:00:00-07:00"); // PST offset is -07:00
    const todayDate = new Date();

    // Adjust todayDate to PST timezone
    const todayPST = new Date(
      todayDate.toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
    );
    const yearDiff = todayPST.getFullYear() - foundedDate.getFullYear();
    const isDate2BeforeBirthday =
      todayPST.getMonth() < foundedDate.getMonth() ||
      (todayPST.getMonth() === foundedDate.getMonth() &&
        todayPST.getDate() < foundedDate.getDate());

    return isDate2BeforeBirthday ? yearDiff - 1 : yearDiff;
  };
  return (
    
    //This Container is for the Make a strong offer section 
    <Container className='BodyWrapper px-0' fluid>
      <Container fluid>
      <Row>
      <Col sm={12} md={4} lg={5}>
        <Image className='HappyCouple' src={HappyCouple} fluid/>
      </Col>
      <Col sm={12} md={8} lg={6}>
      <Image className='RightDotsOffer' src={RightDotsOffer} fluid/>
      <Image className='LeftDotsOffer' src={LeftDotsOffer} fluid/>
        <h2 className='Offer h2customClass'>Make a strong offer on your dream home!</h2>
        <p className='FirstParagraph'>
          {parser(sunwestLink1)} is pleased to introduce the “Early PIW” service. With this new
          service you can verify eligibility for a Property Inspection Waiver &#40;PIW&#41; even
          before an offer is accepted. Homebuyers can take advantage of this service
          to submit a strong offer with the assurance that the property value will not
          be a factor to close the loan.</p>

          <p className='FirstParagraph'>The competition for buying a home is fierce right now. An Early PIW can
          provide a leg up on the competition and get homebuyers into their dream
          home quickly and easily.</p>

          <p className='FirstParagraph'>According to {parser(pavanLink)}, CEO of {parser(sunwestLink1)}, “Checking for PIW availability
          prior to making an offer, can save time and money, and strengthen the offer.
          The process is quick and easy. A no-appraisal contingency along with {parser(sunwestLink1)} backed <a href='https://www.swmc.com/truapproval/' target='_blank' rel='noreferrer'>TRU Approval®</a> makes the offer the obvious choice for the
          seller.”</p>

          <p className='LastOfferParagraph'>Knowing your eligibility for an Early PIW is easy. All we need is an
          authorization to pull credit or a copy of the buyers&#39; credit reports, along with
          some basic information such as the loan amount, the purchase price, the
          property address, and the buyers&#39; current addresses. Contact {parser(sunwestLink1)} at{" "}
          <a href='tel:+18334786937'>(833) 478-6937</a>{" "}today to fast track your clients&#39; home buying process with
          an Early PIW.</p>
        
      </Col>
      </Row>
      </Container>
      {/* This Container is for the About Sun West Mortagage Company section */}
      <Container  id="AboutContainer" className="About py-4" fluid>
      
      <Row className='AboutRow'>
      <Image className='LeftDots' src={LeftDots} fluid/>
        <Image className='RightDots' src={RightDots} fluid/>
        <Col sm={12} md={8} lg={5}>        
        <h2 className='Abouth2 h2customClass'>About {parser(sunwestLink2)}:</h2>
        <p className='AboutParagraph'>At {parser(sunwestLink)} we dedicate ourselves to offering the
           best service to our customers. To accomplish this, we empower our loan
           officers so that they can find great rates and provide the most fitting loan
           options for each customer &#45; at amazing speed. Our focus on technology
           has given us an edge in the mortgage industry to offer some of the fastest
           turn times available &#45; so the customer can get into the home of their
           dreams sooner!</p>

          <p className='AboutParagraph'>We are committed to our core values of people, experience, technology,
          and product. {parser(sunwestLink1)} was founded in 1980 with the prospective of
          "customers first" and the desire to make the mortgage process easy and
          stress-free for prospective homeowners. Since then, {parser(sunwestLink1)} has been
          servicing a multi-billion-dollar loan portfolio and is licensed in 50 states,
          the District of Columbia, Puerto Rico, and the US Virgin Islands. Our {getSunWestSuccessYears()} years
          of experience has been passed down to everyone here at {parser(sunwestLink1)} through excellent leadership and capabilities.
        </p>
        </Col>
      <Col sm={12} className="d-md-none">
        <Image className='AboutGroup' src={AboutGroupMobile} fluid/>
      </Col>
      <Col md={4} className="d-none d-md-block" style={{margin: "36px 0 100px 0"}}>
        <Image className='AboutGroup' src={AboutGroup} fluid/>
      </Col>
      </Row>
      
      </Container>
      <Container className='LastParagrapghContainer' fluid>
        <Row className='LastParagraph'>
          <Col sm={12}>
          <p className='Disclaimer py-5'>
          This information is provided to licensed mortgage professionals only and not for distribution to consumers.<br/>In all jurisdictions, the principal (main) licensed location of {parser(sunwestLink)} is{' '} 
          {footerInfoData && (
          <a
              style={{ color: "#083F88" }}
              target="_blank"
              className='address'
              href={
                footerInfoData.contactUs.address.googleMapsUrl
              }
              rel="noopener"
            >
              {footerInfoData.contactUs.address.fullAddress}
            </a>)}, Phone: <a className='ancherTag' href='tel:+18334786937'>(833) 478-6937</a>.<br />
          </p>
          </Col>
        </Row>
      </Container>
    </Container>
  )
}
